import { defineNuxtPlugin } from '#app'
import VueGtm from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
    
    const siteStore = useSiteStore()

    const gtmId = siteStore.siteConfig.elements?.googleTagManagerId
    
    if (!gtmId?.value) return

    nuxtApp.vueApp.use(VueGtm, {
      id: gtmId.value,
      enabled: !!gtmId.value,
      debug: false, // set true to see logs
      vueRouter: nuxtApp.$router
    })
})